// TODO: The below translations are hardcoded and will likely be moved to Amplience
export const defaultText = {
  productShippingEstimatesDisclaimer: {
    disclaimer: 'Disclaimer',
    deliveryTime: 'Delivery time',
    deliveryTimeDescription:
      'We do everything to make this article on time. However, it is possible that in some cases the delivery is delayed due to circumstances.',
    deliveryOptions: 'Delivery Options',
    deliveryOptionsDescription:
      'We offer several options for delivering or retrieving your order. What options are available for your order, you will see at the end of the order.',
    confirm: 'Okay, I get it',
  },
  recommendationsComponent: {
    completeTheLook: 'complete the look',
    youMayAlsoLike: 'you may also like',
    recentlyViewed: 'recently viewed',
    completeTheLookTitle: 'Complete The Look',
    recentlyViewedTitle: 'Recently Viewed',
    youMayAlsoLikeTitle: 'You May Also Like',
    categoriesTitle: 'View More Categories',
  },
  exitIntentBannerProduct: {
    size: 'size',
    sizeError: 'Please enter your size',
    waist: 'waist',
    waistError: 'Please enter your waist',
    length: 'length',
    lengthError: 'Please enter your length',
    loading: 'loading...',
    addToBag: 'add to bag',
  },
};
